import React from "react";
import EmojiConveyor from "./EmojiConveyor";
import GameGrid from "./GameGrid";
import ScoreLedger from "./ScoreLedger";

export default function EmojiGameScreen({ game }) {
  const {
    visibleEmojis,
    score,
    scoreLedger,
    combo,
    accuracy,
    progress,
    elapsed,
    gameMessage,
    goldenEmojiId,
    treasureEmojiId,
    onEmojiTap,
    freezeGame,
    freezeUntil,
    playing,
    settings,
    grid,
    gridCapacity,
    setScreen,
    frozen,
    beginPlaying,
  } = game;

 return (
  <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white flex flex-col border-t-2 border-cyan-200 py-2 round-2xl">
    <div className="sticky top-0 z-30 bg-slate-950/90 backdrop-blur border-b border-cyan-500/20 px-3 py-2">
      <div className="flex items-center justify-between mt-8">
        <div className="text-cyan-200 text-lg lg:text-xl">😀 WonderEmojis - Fill the grid to win 🎉</div>   

        <div className="text-right text-sm">
          <div className="text-orange-400 font-black">🔥 {combo}</div>
          <div className="text-slate-400 text-sm">Combo</div>
        </div>
      </div>
      
      <div className="text-sm text-slate-300">
        👆 Tap the correct {settings.category} emojis! Golden ⭐ and Treasure 💎 give big bonus points!
      </div>

      <div className="mt-2 h-2 bg-slate-800 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-cyan-400 via-violet-500 to-pink-500"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>

    <div className="px-3 py-2 flex justify-between text-sm">
      <div className="text-green-400 font-black">⭐ {score}</div>
      <div className="text-cyan-300">🎯 {accuracy}% Accuracy</div>
      <div className="text-orange-300">⏱ {(elapsed / 1000).toFixed(1)}s</div>
    </div>

    <div className="flex justify-center items-center px-3 pb-2">
      <ScoreLedger
        scoreLedger={scoreLedger}
        finalScore={score}
      />
    </div>      

    <GameGrid game={game} />

    <EmojiConveyor
        emojis={visibleEmojis}
        onTap={onEmojiTap}
        goldenEmojiId={goldenEmojiId}
        treasureEmojiId={treasureEmojiId}
        disabled={frozen || !playing}
        playing={playing}
        gridCols={3}
        category={settings.category}
        collected={grid.length}
        total={gridCapacity}
        freezeGame={freezeGame}
        freezeUntil={freezeUntil}
        setScreen={setScreen}
        onStart={beginPlaying}
      />
  </div>
  );
}